/**
 * Created by juan on 26/04/2018.
 */
import * as mediaQueries from '../../../utilities/js/mediaQueries';
// Encapsulating the menu functions in a variable
var mmCondensed = {
    // Grabbing all the first level items
    getMegaMenu: jQuery(".js-mm-condensed"),
    getTopListItems: function () {
        return this.getMegaMenu.find(".c-mm-condensed__top-items > li");
    },
    getTabsNavGroups: function () {
        return this.getMegaMenu.find(".js-mm-tabs-nav");
    },
    activeClass: "is-active",
    isOpen: "is-open",
    focusedClass: "is-focused",
    backdropSelector: ".js-mm-backdrop",
    mobileMenuOpenerSelector: ".js-mm-mobile-menu-opener",
    dropDownSelector: ".js-mm-dropdown",
    GTMEventCategoryTopLink: null,
    GTMTopNavCategory: "MM_Top_Nav",
    GTMEventActionHover: "Hover",
    GTMEventActionLinkClick: "Link_Click_",
    GTMEventLabelTopNavClose: "Top-Nav_Close_",
    GTMEventLabelTabShow: "Tab_Show_",
    GTMMegaMenuEventCategoryPrefix: "MM_",
    GTMEventActionClick: "Click",
    GTMEventLabelTabClick: "Tab_Click_",
    GTMEventLabelTabCategory: null,
    GTMTimeOpenedCounter: 0,
    debug: false,
    smallScreensBreakPoint: mediaQueries.smallBreakpoint,
    backdrop: '<div class="js-mm-backdrop c-mm-condensed__back-drop" style="display: none;"></div>',
    mobileBurgerMenuIcon: '<div class="c-mm-condensed__mobile-menu-opener js-mm-mobile-menu-opener" role="button" aria-label="Navigation Menu">' +
        '<svg class="mm-menu-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="14" xmlns:v="https://vecta.io/nano">' +
        '<path d="M17.26 12.064a.5.5 0 1 1 0 1H.5a.5.5 0 1 1 0-1h16.76zm2.24-6a.5.5 0 1 1 0 1H2.74a.5.5 0 1 1 0-1H19.5zm-2.24-6a.5.5 0 1 1 0 1H.5a.5.5 0 1 1 0-1h16.76z" fill="#161616" fill-rule="nonzero"/>' +
        "</svg>" +
        '<svg class="mm-close-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="13" xmlns:v="https://vecta.io/nano">' +
        '<path d="M.567.6L6 6.033 11.433.6a.33.33 0 0 1 .467.467L6.473 6.5l5.427 5.433a.32.32 0 0 1 0 .467c-.06.065-.145.1-.233.1s-.173-.035-.233-.1L6 6.966.567 12.4c-.06.065-.145.1-.233.1S.16 12.465.1 12.4a.32.32 0 0 1 0-.467L5.527 6.5.1 1.067A.33.33 0 0 1 .1.6.33.33 0 0 1 .567.6z" fill="#161616" fill-rule="nonzero"/>' +
        "</svg>" +
        "</div>",
    // Checking if there are tabs
    areThereTabs: function () {
        return document.querySelectorAll(".js-mm-tabs-nav").length > 0;
    },
    isASmallScreen: function () {
        return window.innerWidth < this.smallScreensBreakPoint;
    },
    logDataLayer: function (debug) {
        if (debug) {
            var s = window.dataLayer.length;
            console.log(window.dataLayer[s - 1]);
        }
    },
    backdropLayerInit: function () {
        if (document.querySelectorAll(this.backdropSelector).length === 0) {
            // Insert the backdrop
            jQuery(this.backdrop).insertAfter(this.getMegaMenu);
        }
        else {
            jQuery(this.backdropSelector).hide();
        }
    },
    initialiseMenu: function () {
        // This method adds/removes the burger menu and it opens/closes the menu
        // too on mobile
        var body = document.querySelector("body");
        // Handle the backdrop layer
        this.backdropLayerInit();
        // If on a small screen
        if (this.isASmallScreen() === true) {
            this.initialiseMenuOnSmallScreens(body);
        }
        // Else, on a medium up screen
        else {
            this.initialiseMenuOnMediumUpScreens(body);
        }
        document.querySelectorAll('.c-mm-condensed.js-mm-condensed div[role="tabpanel"] li').forEach(function (li) {
            if (!li.hasAttribute("class") || li.getAttribute("class") === "") {
                li.querySelectorAll("a").forEach(function (anchor) {
                    anchor.classList.add("boi-link-no-underline");
                });
            }
        });
        document.querySelectorAll('.c-mm-condensed.js-mm-condensed div[role="tabpanel"] a[class="button link arrow-right"]').forEach(function (a) {
            a.classList.add("button-link");
        });
        document.querySelectorAll('.c-mm-condensed.js-mm-condensed div[role="tabpanel"] a').forEach(function (link) {
            if (link.textContent.trim() === "View all") {
                link.classList.add('boi-link-no-underline');
            }
        });
    },
    initialiseMenuOnSmallScreens: function (body) {
        var _this = this;
        // If there is no burger icon
        if (document.querySelectorAll(this.mobileMenuOpenerSelector).length === 0) {
            // Insert the burger menu icon
            this.getMegaMenu.prepend(this.mobileBurgerMenuIcon);
        }
        // Binding click and tab events to the burger menu and the backdrop (removing any backdrop listeners from desktop)
        jQuery(this.mobileMenuOpenerSelector + "," + this.backdropSelector)
            .off()
            .on("click", function () {
            // If mega menu is opened, close it
            if (_this.getMegaMenu.hasClass(_this.activeClass)) {
                _this.getMegaMenu.removeClass(_this.activeClass);
                jQuery(_this.backdropSelector).fadeOut();
                body.classList.remove("c-mm-condensed-body-mobile-menu-is-opened");
            }
            // If mega menu is closed, open it
            else {
                _this.getMegaMenu.addClass(_this.activeClass);
                // Display the backdrop too
                jQuery(_this.backdropSelector).fadeIn();
                body.classList.add("c-mm-condensed-body-mobile-menu-is-opened");
            }
        });
    },
    deactivateSearchBar: function () {
        var searchButton = this.getMegaMenu.find(".js-mm-search-button");
        var searchFormWrapper = this.getMegaMenu.find(".js-mm-search-form-wrapper");
        // Hide search bar and change search button class
        searchButton.removeClass(this.activeClass);
        searchFormWrapper.removeClass("is-open");
    },
    initialiseMenuOnMediumUpScreens: function (body) {
        var _this = this;
        // Actions for when coming from Small screen views (i.e. from portrait
        // to landscape mode)
        if (document.querySelectorAll(this.mobileMenuOpenerSelector).length !== 0) {
            // Remove the event listener and the element (note that .remove() does
            // both)
            this.getMegaMenu.find(this.mobileMenuOpenerSelector).remove();
        }
        // Binding click and tab events to the burger menu and the backdrop
        jQuery(this.backdropSelector)
            .off()
            .on("click", function () {
            // If mega menu is opened, close it
            _this.getTopListItems().removeClass(_this.activeClass);
            jQuery(_this.backdropSelector).fadeOut();
            _this.deactivateSearchBar();
        });
        // Removing the class for when the menu is opened
        body.classList.remove("c-mm-condensed-body-mobile-menu-is-opened");
        // Remove the active class from the menu
        this.getMegaMenu.removeClass(this.activeClass);
        // Remove class active from top list items
        this.getTopListItems().removeClass(this.activeClass);
    },
    initialiseTabs: function () {
        var _this = this;
        // This method adds/remove the mobile tabs openers and also setups the
        // initial state of the tab content divs
        // Iterate through the tab groups
        this.getTabsNavGroups().each(function (index, element) {
            var group = jQuery(element), groupItems = group.find("> li"), firstLink = groupItems.first().find("a"), firstTabTargetUrl = firstLink.attr("href");
            // TABS - MENU
            // Small screens initialisation
            if (_this.isASmallScreen() === true) {
                _this.initialiseTabsOnSmallScreens(group, groupItems, firstLink, firstTabTargetUrl);
            }
            else {
                // Medium up screens initialisation
                _this.initialiseTabsOnMediumUpScreens(group, groupItems, firstLink, firstTabTargetUrl);
            }
        });
    },
    initialiseTabsOnSmallScreens: function (group, groupItems, firstLink, firstTabTargetUrl) {
        // Removing the active classes from the first element and its siblings
        groupItems.removeClass(this.activeClass);
        // Removing the dropdown active class if coming from small screen view
        jQuery(this.dropDownSelector)
            .parent()
            .removeClass(this.activeClass);
        // Adding the mobile tab openers
        groupItems.find("a").each(function (index, element) {
            var _linkURL = element.hash;
            // if the href links to a tab
            if (_linkURL !== "") {
                // Get the target
                var target = jQuery(_linkURL);
                // if target exist
                if (target.length > 0) {
                    // Insert the opener under its correspondent content tab
                    target.before(jQuery(element)
                        .clone()
                        .addClass("c-mm-condensed__mobile-tab-opener"));
                }
            }
        });
        groupItems.find("a").off();
        // TABS - CONTENT
        // If target is a hash
        if (firstTabTargetUrl.indexOf("#") === 0) {
            var target = jQuery(firstTabTargetUrl);
            // if target (aka tab content) exists
            if (target.length > 0) {
                // Removing the active classes from the Target tab and its siblings and setting the opacity to 1
                target
                    .removeClass(this.activeClass)
                    .css("opacity", 1)
                    .siblings()
                    .removeClass(this.activeClass)
                    .css("opacity", 1);
            }
        }
    },
    initialiseTabsOnMediumUpScreens: function (group, groupItems, firstLink, firstTabTargetUrl) {
        // Adding the active class to the first tab and removing it from its siblings
        firstLink
            .parent()
            .addClass(this.activeClass)
            .siblings()
            .removeClass(this.activeClass);
        // Removing the style attribute if coming back from mobile view into the desktop one
        jQuery(this.dropDownSelector).removeAttr("style");
        // If there's any tab opener (for when coming form mobile)
        if (document.querySelectorAll(".c-mm-condensed__mobile-tab-opener").length > 0) {
            // Remove the event listener and opener (note that .remove() does
            // both)
            jQuery(".c-mm-condensed__mobile-tab-opener").remove();
        }
        // TABS - CONTENT
        // If target is a hash
        if (firstTabTargetUrl.indexOf("#") === 0) {
            var target = jQuery(firstTabTargetUrl);
            // if target (aka tab content) exists
            if (target.length > 0) {
                // Adding the active class to the Target and removing it from its siblings
                target
                    .addClass(this.activeClass)
                    .removeAttr("style")
                    .css("opacity", 1)
                    .siblings()
                    .removeClass(this.activeClass)
                    .removeAttr("style");
            }
        }
    },
    counter: function () {
        mmCondensed.counterInterval = setInterval(function () {
            // method to be executed;
            mmCondensed.GTMTimeOpenedCounter = mmCondensed.GTMTimeOpenedCounter + 1;
            if (mmCondensed.debug) {
                console.log(mmCondensed.GTMTimeOpenedCounter);
            }
        }, 1000);
    },
    setupTopLinksBehaviour: function () {
        var _this = this;
        // Iterating through the first level items
        this.getTopListItems().each(function (index, element) {
            var $element = jQuery(element);
            // IE Restrict support - preventing the opening of menus on IE
            if (typeof window.IS_IE !== typeof undefined &&
                window.IS_IE &&
                $element.find("> a").hasClass(window.RESTRICT_IE_CLASS)) {
                return true;
            }
            // Checking if the link has a dropdown first
            if ($element.find(_this.dropDownSelector).length > 0) {
                if (_this.isASmallScreen() === true) {
                    // Removing the active class Unbinding the hoverIntent from mobile first
                    $element.removeClass(_this.activeClass).off();
                    // Applying the mobile behaviour
                    _this.topLinksBehaviourOnMobile($element);
                }
                else {
                    // Unbinding the click and tap events from the elements
                    $element.find("> a").off();
                    $element.find(_this.dropDownSelector).removeAttr("style");
                    // Applying the desktop behaviour
                    _this.topLinksBehaviourOnMediumUpScreens($element);
                }
            }
        });
    },
    topLinksBehaviourOnMobile: function ($element) {
        var _this = this;
        $element
            .find("> a")
            .off()
            .on("click tap", function () {
            // Removing the active state from any other item
            $element.siblings().removeClass(_this.activeClass);
            $element
                .siblings()
                .find(_this.dropDownSelector)
                .slideUp();
            if ($element.hasClass(_this.activeClass)) {
                // Removing the active class to he hovered item
                $element.removeClass(_this.activeClass);
                $element.find(_this.dropDownSelector).slideUp();
                _this.dataLayerPush(_this.GTMTopNavCategory, _this.GTMEventActionHover, "Top-Nav_Open_" + _this.GTMEventCategoryTopLink);
                _this.logDataLayer(_this.debug);
            }
            else {
                // Adding the active class to he hovered item
                $element.addClass(_this.activeClass);
                $element.find(_this.dropDownSelector).slideDown();
            }
        });
    },
    topLinksBehaviourOnMediumUpScreens: function ($element) {
        var _this = this;
        var searchButton = this.getMegaMenu.find(".js-mm-search-button");
        var searchFormWrapper = this.getMegaMenu.find(".js-mm-search-form-wrapper");
        $element
            .find("> a")
            .off()
            .on("click tap", function (e) {
            // This to prevent the page from jumping up to top or open a link instead of the dropdown
            e.preventDefault();
            // Removing the active state from any other item
            $element.siblings().removeClass(_this.activeClass);
            _this.deactivateSearchBar();
            if ($element.hasClass(_this.activeClass)) {
                // Removing the active class to he hovered item
                $element.removeClass(_this.activeClass);
                _this.dataLayerPush(_this.GTMTopNavCategory, _this.GTMEventActionHover, "Top-Nav_Open_" + _this.GTMEventCategoryTopLink);
                _this.logDataLayer(_this.debug);
                if (!searchButton.hasClass(_this.activeClass)) {
                    jQuery(_this.backdropSelector).fadeOut();
                }
            }
            else {
                // Adding the active class to he hovered item
                $element.addClass(_this.activeClass);
                jQuery(_this.backdropSelector).fadeIn();
            }
        });
    },
    setupTabsBehaviour: function () {
        var _this = this;
        // Iterate throug every group of navs
        this.getTabsNavGroups().each(function (index, element) {
            var group = jQuery(element);
            var tabsContentGroup = group.parent().next(".js-mm-tabs-content");
            if (_this.isASmallScreen() === true) {
                var tabsBehaviourMobile = tabsContentGroup.find(".c-mm-condensed__mobile-tab-opener");
                _this.tabsBehaviourMobile(tabsBehaviourMobile);
            }
            else {
                var tabsBehaviourDesktop = group.find("a");
                _this.tabsBehaviourDesktop(tabsBehaviourDesktop);
            }
            // Search form
            _this.searchFormInteraction();
        });
    },
    tabsBehaviourDesktop: function (group) {
        var _this = this;
        var tabFocus = 0;
        var updateTabFocus = function (direction) {
            group[tabFocus].setAttribute("tabindex", -1);
            if (direction === 'down') {
                tabFocus = (tabFocus + 1) % group.length;
            }
            else {
                tabFocus = (tabFocus - 1 + group.length) % group.length;
            }
            group[tabFocus].setAttribute("tabindex", 0);
            group[tabFocus].focus();
        };
        group.on("keydown", function (e) {
            if (e.key === "ArrowDown") {
                updateTabFocus('down');
            }
            else if (e.key === "ArrowUp") {
                updateTabFocus('up');
            }
        });
        group.each(function (index, element) {
            jQuery(element).on("click tap", function (e) {
                // Prevent the click to make the page jump up
                e.preventDefault();
                var _link = jQuery(e.currentTarget), _linkURL = _link.attr("href");
                // if the href links off to a tab
                if (_linkURL.indexOf("#") === 0) {
                    var target = jQuery(_linkURL);
                    // if such tab exist
                    if (target.length > 0) {
                        if (_link.hasClass(_this.activeClass)) {
                            // Remove active class from its own <li> element
                            _link.parent().removeClass(_this.activeClass);
                            // Remove active class from other tab navs
                            _link
                                .parent()
                                .siblings()
                                .removeClass(_this.activeClass);
                            target.removeClass(_this.activeClass).css({ opacity: 0 });
                        }
                        else {
                            // Desktop
                            _link.parent().addClass(_this.activeClass);
                            _link
                                .parent()
                                .siblings()
                                .removeClass(_this.activeClass);
                            target.addClass(_this.activeClass).animate({ opacity: 1 }, 500);
                            target
                                .siblings(".c-mm-condensed__tab-content")
                                .removeClass(_this.activeClass)
                                .css({ opacity: 0 });
                        }
                        target.find('a')[0].setAttribute("tabindex", 0);
                        target.find('a')[0].focus();
                        _this.tabGTMPush(_link);
                    }
                }
                else {
                    // Else, redirect to the page where the href points to
                    _this.goToLink(_linkURL);
                }
            });
        });
    },
    tabsBehaviourMobile: function (group) {
        var _this = this;
        group.each(function (index, element) {
            jQuery(element).on("click tap", function (e) {
                // Prevent the click to make the page jump up
                e.preventDefault();
                var _link = jQuery(e.currentTarget), _linkURL = _link.attr("href");
                // if the href links off to a tab
                if (_linkURL.indexOf("#") === 0) {
                    var target = jQuery(_linkURL);
                    // if such tab exist
                    if (target.length > 0) {
                        // And if it has the active class
                        if (_link.hasClass(_this.activeClass)) {
                            // MAIN ACTIONS
                            // Remove class from itself
                            _link.removeClass(_this.activeClass);
                            target.removeClass(_this.activeClass).slideUp();
                            // Remove class from siblings
                            _link.siblings("a").removeClass(_this.activeClass);
                            target
                                .siblings(".c-mm-condensed__tab-content")
                                .removeClass(_this.activeClass)
                                .slideUp();
                        }
                        else {
                            // MAIN ACTIONS
                            _link.addClass(_this.activeClass);
                            target.addClass(_this.activeClass);
                            _link.siblings("a").removeClass(_this.activeClass);
                            target
                                .siblings(".c-mm-condensed__tab-content")
                                .removeClass(_this.activeClass)
                                .slideUp();
                            target.slideDown();
                        }
                        _this.tabGTMPush(_link);
                    }
                }
                else {
                    // Else, redirect to the page where the href points to
                    _this.goToLink(_linkURL);
                }
            });
        });
    },
    tabGTMPush: function (link) {
        this.GTMEventLabelTabCategory = null;
        this.GTMEventLabelTabCategory = link[0].innerText;
        this.dataLayerPush(this.GTMMegaMenuEventCategoryPrefix + this.GTMEventCategoryTopLink, this.GTMEventActionClick, this.GTMEventLabelTabShow + this.GTMEventLabelTabCategory);
        this.logDataLayer(this.debug);
    },
    goToLink: function (tabUrl) {
        location.href = tabUrl;
        this.dataLayerPush(this.GTMTopNavCategory, this.GTMEventActionHover, this.GTMEventLabelTopNavClose + this.GTMEventCategoryTopLink, this.GTMTimeOpenedCounter);
        this.logDataLayer(this.debug);
        // TODO: investigate commented out code
        this.GTMEventLabelTabCategory = null;
        // this.GTMEventLabelTabCategory = _link[0].innerText;
        this.dataLayerPush(this.GTMMegaMenuEventCategoryPrefix + this.GTMEventCategoryTopLink, this.GTMEventActionClick, this.GTMEventLabelTabClick + this.GTMEventLabelTabCategory);
        this.logDataLayer(this.debug);
    },
    triggerAbTest: function (menuASelector, menuBSelector) {
        var menuA = document.querySelectorAll(menuASelector), menuB = document.querySelectorAll(menuBSelector);
        if (menuA.length > 0 && menuB.length > 0) {
            menuA[0].style.display = "none";
            menuB[0].style.display = "block";
        }
    },
    searchForm: function () {
        return this.getMegaMenu.find(".js-mm-search-form");
    },
    searchFormInteraction: function () {
        var _this = this;
        if (this.searchForm().length) {
            var inputSearch = this.searchForm().find('input[type="search"]'), button = this.searchForm().find("button");
            inputSearch
                .focus(function () {
                _this.searchForm().addClass(_this.focusedClass);
            })
                .focusout(function () {
                _this.searchForm().removeClass(_this.focusedClass);
            });
            button.on("click tap", function () {
                _this.searchForm().submit();
            });
        }
    },
    searchButtonToggle: function () {
        var _this = this;
        var searchFormWrapper = this.getMegaMenu.find(".js-mm-search-form-wrapper");
        var searchButton = this.getMegaMenu.find(".js-mm-search-button");
        var searchInput = searchFormWrapper.find(".js-c-search-form-input");
        var dropdownSelector = jQuery(".js-mm-backdrop");
        if (this.searchForm().length && searchButton.length) {
            searchButton.on("click tap", function (e) {
                e.preventDefault();
                // Hide search bar
                searchFormWrapper.toggleClass("is-open");
                // Change search button content and hide
                if (searchButton.hasClass(_this.activeClass)) {
                    searchButton.removeClass(_this.activeClass);
                }
                else {
                    searchButton.addClass(_this.activeClass);
                }
                // Hide dropdown
                dropdownSelector.fadeOut(10);
                // Hide all open dropdown content
                _this.getTopListItems().removeClass(_this.activeClass);
                setTimeout(function () {
                    searchInput.focus();
                }, 1500);
            });
        }
    },
    linksBehaviourInitialised: false,
    linksBehaviour: function () {
        var _this = this;
        var allLinks = this.getMegaMenu
            .find(".js-mm-dropdown a")
            .not(".js-mm-tabs-nav a");
        // Iterate through it
        allLinks.each(function (index, element) {
            jQuery(element).on("click tap", function (e) {
                _this.linkText = e.currentTarget;
                var cta = jQuery(e.currentTarget).attr("data-cta");
                if (jQuery(e.currentTarget).closest(".c-mm-condensed__tab-content").length === 0) {
                    if (typeof cta !== typeof undefined && cta !== false) {
                        _this.dataLayerPush(_this.GTMMegaMenuEventCategoryPrefix +
                            _this.GTMEventCategoryTopLink, _this.GTMEventActionClick, _this.GTMEventActionLinkClick + cta);
                        _this.logDataLayer(_this.debug);
                    }
                    else {
                        _this.dataLayerPush(_this.GTMMegaMenuEventCategoryPrefix +
                            _this.GTMEventCategoryTopLink, _this.GTMEventActionClick, _this.GTMEventActionLinkClick + _this.linkText.innerText);
                        _this.logDataLayer(_this.debug);
                    }
                }
                else {
                    if (typeof cta !== typeof undefined && cta !== false) {
                        _this.dataLayerPush(_this.GTMMegaMenuEventCategoryPrefix +
                            _this.GTMEventCategoryTopLink, _this.GTMEventActionClick, _this.GTMEventActionLinkClick +
                            _this.GTMEventLabelTabCategory +
                            "_" +
                            cta);
                        _this.logDataLayer(_this.debug);
                    }
                    else {
                        _this.dataLayerPush(_this.GTMMegaMenuEventCategoryPrefix +
                            _this.GTMEventCategoryTopLink, _this.GTMEventActionClick, _this.GTMEventActionLinkClick +
                            _this.GTMEventLabelTabCategory +
                            "_" +
                            _this.linkText.innerText);
                        _this.logDataLayer(_this.debug);
                    }
                }
            });
        });
        // Marking the links behaviour as already initialised
        this.linksBehaviourInitialised = true;
    },
    dataLayerPush: function (eventCategory, eventAction, eventLabel, counter) {
        if (counter) {
            window.dataLayer.push({
                event: "clickEvent",
                eventCategory: eventCategory,
                eventAction: eventAction,
                eventLabel: eventLabel,
                counter: counter
            });
        }
        else {
            window.dataLayer.push({
                event: "clickEvent",
                eventCategory: eventCategory,
                eventAction: eventAction,
                eventLabel: eventLabel
            });
        }
    },
    onResizeReInit: function () {
        this.initialiseMenu();
        this.setupTopLinksBehaviour();
        // Checking this initialisation has been performed already
        if (this.linksBehaviourInitialised === false) {
            this.linksBehaviour();
            this.searchButtonToggle();
        }
        if (this.areThereTabs()) {
            this.initialiseTabs();
            this.setupTabsBehaviour();
        }
    }
};
(function (browser) {
    // Checking if the mega menu exists and if jQuery and  the breakpoint utils are defined
    if (document.querySelectorAll('.js-mm-condensed').length > 0 &&
        browser.jQuery &&
        typeof browser.boiGlobalConstants !== 'undefined' &&
        typeof browser.watchXAxisBreakpoint !== 'undefined' &&
        typeof mmCondensed === 'object') {
        // Watching the mobile breakpoint and re assembling the menu if the breakpoint is passed
        browser.watchXAxisBreakpoint(browser.boiGlobalConstants().smallBreakpoint, mmCondensed.onResizeReInit.bind(mmCondensed), mmCondensed.onResizeReInit.bind(mmCondensed), true);
    }
})(window);
